import { useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { Modal, Box, Typography, Button } from "@mui/material";
import SessionTimeout from "../../../assets/SessionTimeout.svg";
import { useNavigate } from "react-router-dom";
import { useAuth, useTokens } from "../../../shared/hooks";
import { useDispatch } from "react-redux";
import { setIdleTimeout } from "./idleTimeOut.slice";

const IDLE_TIMEOUT = 5 * 60 * 1000;

const IdleTimeout = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { logout } = useAuth();
  const { clearTokens } = useTokens();
  const dispatch=useDispatch()

  const handleIdle = async () => {
    
    //dispatch(setIdleTimeout({ timeout:true}));
    await logout(false, false, true);
    //setOpen(true);
  };


  

  

  const handleSignIn = async () => {
    await logout();
    clearTokens();
    navigate("/login");
  };

  useIdleTimer({
    timeout: IDLE_TIMEOUT,
    onIdle: handleIdle,
    debounce: 500,
  });

  return (
    <Modal 
      open={open} 
      onClose={() => {}}
      sx={{
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        }
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
          p: 4,
          borderRadius: 2,
          border: "none",
          outline: "none",
          zIndex: 9999,
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <img src={SessionTimeout} alt="" style={{marginBottom:10}}/>
          <Typography variant="h6" gutterBottom sx={{ color: "#FD6165",fontWeight:"700",fontSize:"16px",lineHeight:"18.75px" }}>
            Session Timeout
          </Typography>
          <Typography variant="body2" gutterBottom sx={{ fontWeight: "400", fontSize: "13px", lineHeight: "18px", color: "#666666" }}>
            Your session has been timed out. Sign in again to
          </Typography>
          <Typography variant="body2" gutterBottom sx={{ fontWeight: "400", fontSize: "13px", lineHeight: "18px", color: "#666666", mb: 2 }}>
            Proceed with the system.
          </Typography>
          <Button 
            variant="contained" 
            onClick={handleSignIn} 
            sx={{
              width:"132px",
              height:"42px",
              borderRadius:"4px",
              lineHeight:"18px",
              fontSize:"13px",
              '&:hover': {
                backgroundColor: '#FD6165',
              }
            }}
          >
            Sign In
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default IdleTimeout;
